import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import TagManager from 'react-gtm-module';
import * as serviceWorker from './serviceWorker';

import App from './containers/App';

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID,
  dataLayer: {},
};

if (process.env.NODE_ENV !== 'production') {
  tagManagerArgs['auth'] = 'cIbY-s0H-cms-MiYD9moEg';
  tagManagerArgs['preview'] = 'env-5';
}

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
